import { render, staticRenderFns } from "./addHeader.vue?vue&type=template&id=b48ea1f6&scoped=true&"
import script from "./addHeader.vue?vue&type=script&lang=js&"
export * from "./addHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48ea1f6",
  null
  
)

export default component.exports